import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  form: {
    width: 550,
    maxWidth: '100vw'
  },
  link: {
    textDecoration: 'none'
  },
  note: {
    fontSize: '0.75em'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/bulkupload/BulkUploadFileForm.styles.js